module.exports = __webpack_public_path__ + "assets/img/LX.e48b5f37.png";